/*
 *
 * SignUpPage reducer
 *
 */
const initialState = {
  canSubmit: false,
  error: false,
  success: false,
  errorMessage: '',
  paying: false,
};

function niceChoiceReducer(state = initialState, action) {
  switch (action.type) {
    case 'TOKEN_SUCCESS':
      return {
        ...state,
        canSubmit: true,
      }
      case 'PLAN_SUBSCRIPTION_ERROR':
        return {
          ...state,
          error: true,
          success: false,
        }

      case 'PLAN_SUBSCRIPTION_SUCCESS':
        return {
          ...state,
          success: true,
          error: false,
        }
      case 'CARD_DETAILS_ERROR':
        return{
          ...state,
          errorMessage: action.payload,
        }
      case 'CARD_DETAILS_RESET_ERROR':
        return{
          ...state,
          errorMessage: null,
        }
      case 'RESET_ERROR':
        return {
          ...state,
          success: false,
          error: false,
          canSubmit: false,
        }
      case 'TOGGLE_PAYING':
        return{
          ...state,
          paying: !state.paying
        }
    default:
      return state;
  }
}

export default niceChoiceReducer;



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/reducer.js